import { render, staticRenderFns } from "./GeofenceList.vue?vue&type=template&id=36404c90&scoped=true&"
import script from "./GeofenceList.vue?vue&type=script&lang=js&"
export * from "./GeofenceList.vue?vue&type=script&lang=js&"
import style0 from "./GeofenceList.vue?vue&type=style&index=0&id=36404c90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36404c90",
  null
  
)

export default component.exports